// Phone model catalogue.
// Naming convention:  <slug>_01.png = MASK (dark case, white cutout)
//                     <slug>_02.png = MOCKUP (transparent case + real camera + edge outline)
// Add new models below — dropdown order = order in this array.

const ASSET_BASE =
    "https://customer-assets.emergentagent.com/job_phone-case-designer-2/artifacts";

export const PHONE_MODELS = [
    {
        id: "ip17promax",
        brand: "Apple",
        name: "iPhone 17 Pro Max",
        mask: `${ASSET_BASE}/074tpeym_ip17promax_01.png`,
        mockup: `${ASSET_BASE}/e4a1dgin_ip17promax_02.png`,
    },
    {
        id: "ip17pro",
        brand: "Apple",
        name: "iPhone 17 Pro",
        mask: `${ASSET_BASE}/jlnhpro2_ip17pro_01.png`,
        mockup: `${ASSET_BASE}/jhaylwzp_ip17pro_02.png`,
    },
    {
        id: "ip17air",
        brand: "Apple",
        name: "iPhone 17 Air",
        mask: `${ASSET_BASE}/lqjamfbb_ip17air_01.png`,
        mockup: `${ASSET_BASE}/waw3m1mh_ip17air_02.png`,
    },
    {
        id: "ip17",
        brand: "Apple",
        name: "iPhone 17",
        mask: `${ASSET_BASE}/y3y9t3wf_ip17_01.png`,
        mockup: `${ASSET_BASE}/ryc511fs_ip17_02.png`,
    },
    {
        id: "ip16promax",
        brand: "Apple",
        name: "iPhone 16 Pro Max",
        mask: `${ASSET_BASE}/5m5gnjfs_iphone_16_pro_max_01.png`,
        mockup: `${ASSET_BASE}/k6qeil1i_iphone_16_pro_max_02.png`,
    },
    {
        id: "ip16pro",
        brand: "Apple",
        name: "iPhone 16 Pro",
        mask: `${ASSET_BASE}/u48igojt_iphone_16_pro_01.png`,
        mockup: `${ASSET_BASE}/dfi90yem_iphone_16_pro_02.png`,
    },
    {
        id: "ip16plus",
        brand: "Apple",
        name: "iPhone 16 Plus",
        mask: `${ASSET_BASE}/0y9tzz0m_iphone_16_plus_01.png`,
        mockup: `${ASSET_BASE}/lohedfio_iphone_16_plus_02.png`,
    },
    {
        id: "ip16",
        brand: "Apple",
        name: "iPhone 16",
        mask: `${ASSET_BASE}/v2xxlhfd_iphone_16_01.png`,
        mockup: `${ASSET_BASE}/gcwc2f43_iphone_16_02.png`,
    },
    {
        id: "ip16e",
        brand: "Apple",
        name: "iPhone 16e",
        mask: `${ASSET_BASE}/u8g9l4zi_iphone_16e_01.png`,
        mockup: `${ASSET_BASE}/w3apgfjj_iphone_16e_02.png`,
    },
    {
        id: "ip15promax",
        brand: "Apple",
        name: "iPhone 15 Pro Max",
        mask: `${ASSET_BASE}/jumvmir5_iphone_15_pro_max_01.png`,
        mockup: `${ASSET_BASE}/33xjw476_iphone_15_pro_max_02.png`,
    },
    {
        id: "ip15pro",
        brand: "Apple",
        name: "iPhone 15 Pro",
        mask: `${ASSET_BASE}/9ctwy9u4_iphone_15_pro_01.png`,
        mockup: `${ASSET_BASE}/9cnxwdz2_iphone_15_pro_02.png`,
    },
    {
        id: "ip15plus",
        brand: "Apple",
        name: "iPhone 15 Plus",
        mask: `${ASSET_BASE}/47yjsg8p_iphone_15_plus_01.png`,
        mockup: `${ASSET_BASE}/utgqx9pl_iphone_15_plus_02.png`,
    },
    {
        id: "ip15",
        brand: "Apple",
        name: "iPhone 15",
        mask: `${ASSET_BASE}/bou7avie_iphone_15_01.png`,
        mockup: `${ASSET_BASE}/g1vrnrv9_iphone_15_02.png`,
    },
    {
        id: "ip14promax",
        brand: "Apple",
        name: "iPhone 14 Pro Max",
        mask: `${ASSET_BASE}/wsxqh4ru_iphone_14_pro_max_01.png`,
        mockup: `${ASSET_BASE}/o63jjrlf_iphone_14_pro_max_02.png`,
    },
    {
        id: "ip14pro",
        brand: "Apple",
        name: "iPhone 14 Pro",
        mask: `${ASSET_BASE}/recoyp9h_iphone_14_pro_01.png`,
        mockup: `${ASSET_BASE}/xf9xk32x_iphone_14_pro_02.png`,
    },
    {
        id: "ip14plus",
        brand: "Apple",
        name: "iPhone 14 Plus",
        mask: `${ASSET_BASE}/pg5cxoq9_iphone_14_plus_01.png`,
        mockup: `${ASSET_BASE}/5dofqtrf_iphone_14_plus_02.png`,
    },
    {
        id: "ip14",
        brand: "Apple",
        name: "iPhone 14",
        mask: `${ASSET_BASE}/em819w1x_iphone_14_01.png`,
        mockup: `${ASSET_BASE}/80pgltus_iphone_14_02.png`,
    },
    {
        id: "ip13promax",
        brand: "Apple",
        name: "iPhone 13 Pro Max",
        mask: `${ASSET_BASE}/qipr8ash_iphone_13_pro_max_01.png`,
        mockup: `${ASSET_BASE}/z4zrv3wi_iphone_13_pro_max_02.png`,
    },
    {
        id: "ip13pro",
        brand: "Apple",
        name: "iPhone 13 Pro",
        mask: `${ASSET_BASE}/77cs9ngi_iphone_13_pro_01.png`,
        mockup: `${ASSET_BASE}/nix3wwtf_iphone_13_pro_02.png`,
    },
    {
        id: "ip13",
        brand: "Apple",
        name: "iPhone 13",
        mask: `${ASSET_BASE}/52e6uoqq_iphone_13_01.png`,
        mockup: `${ASSET_BASE}/o8fxfp0r_iphone_13_02.png`,
    },
    {
        id: "ip12promax",
        brand: "Apple",
        name: "iPhone 12 Pro Max",
        mask: `${ASSET_BASE}/wqeezl4a_iphone_12_pro_max_01.png`,
        mockup: `${ASSET_BASE}/y6t4g8nx_iphone_12_pro_max_02.png`,
    },
    {
        id: "ip12pro",
        brand: "Apple",
        name: "iPhone 12 Pro",
        mask: `${ASSET_BASE}/jxvqpq9p_iphone_12_pro_01.png`,
        mockup: `${ASSET_BASE}/ut7l5mhj_iphone_12_pro_02.png`,
    },
    {
        id: "ip12",
        brand: "Apple",
        name: "iPhone 12",
        mask: `${ASSET_BASE}/air25won_iphone_12_01.png`,
        mockup: `${ASSET_BASE}/d1eu3v7z_iphone_12_02.png`,
    },
    {
        id: "ip11promax",
        brand: "Apple",
        name: "iPhone 11 Pro Max",
        mask: `${ASSET_BASE}/1wv4aw2m_iPhone_11_ProMax_01.png`,
        mockup: `${ASSET_BASE}/bfkk5hc7_iPhone_11_ProMax_02.png`,
    },
    {
        id: "ip11pro",
        brand: "Apple",
        name: "iPhone 11 Pro",
        mask: `${ASSET_BASE}/d7jdcizj_iPhone_11_Pro_01.png`,
        mockup: `${ASSET_BASE}/tejh57hr_iPhone_11_Pro_02.png`,
    },
    {
        id: "ip11",
        brand: "Apple",
        name: "iPhone 11",
        mask: `${ASSET_BASE}/rzod95ec_iPhone_11_01.png`,
        mockup: `${ASSET_BASE}/0wzzvjyp_iPhone_11_02.png`,
    },
    {
        id: "s25u",
        brand: "Samsung",
        name: "Galaxy S25 Ultra",
        mask: `${ASSET_BASE}/nno6kouh_galaxy_s25_u_01.png`,
        mockup: `${ASSET_BASE}/zkuzogj0_galaxy_s25_u_02.png`,
    },
    {
        id: "s25plus",
        brand: "Samsung",
        name: "Galaxy S25+",
        mask: `${ASSET_BASE}/g1tchbwj_galaxy_s25_p_01.png`,
        mockup: `${ASSET_BASE}/bc4oxsei_galaxy_s25_p_02.png`,
    },
    {
        id: "s25",
        brand: "Samsung",
        name: "Galaxy S25",
        mask: `${ASSET_BASE}/blzj8804_galaxy_s25_01.png`,
        mockup: `${ASSET_BASE}/5ipzh3ff_galaxy_s25_02.png`,
    },
    {
        id: "s24u",
        brand: "Samsung",
        name: "Galaxy S24 Ultra",
        mask: `${ASSET_BASE}/nmy5sy42_galaxy_s24_u_01.png`,
        mockup: `${ASSET_BASE}/1yidi7q4_galaxy_s24_u_02.png`,
    },
    {
        id: "s24plus",
        brand: "Samsung",
        name: "Galaxy S24+",
        mask: `${ASSET_BASE}/901ng9ih_galaxy_s24_p_01.png`,
        mockup: `${ASSET_BASE}/jtda8kh1_galaxy_s24_p_02.png`,
    },
    {
        id: "s24",
        brand: "Samsung",
        name: "Galaxy S24",
        mask: `${ASSET_BASE}/jmspwa9f_galaxy_s24_01.png`,
        mockup: `${ASSET_BASE}/hc502kax_galaxy_s24_02.png`,
    },
    {
        id: "s24fe",
        brand: "Samsung",
        name: "Galaxy S24 FE",
        mask: `${ASSET_BASE}/roi1d1ca_galaxy_s24_fe_01.png`,
        mockup: `${ASSET_BASE}/4cwrsg10_galaxy_s24_fe_02.png`,
    },
    {
        id: "s23u",
        brand: "Samsung",
        name: "Galaxy S23 Ultra",
        mask: `${ASSET_BASE}/m07tvkbt_galaxy_s23_u_01.png`,
        mockup: `${ASSET_BASE}/mr4uqwe0_galaxy_s23_u_02.png`,
    },
    {
        id: "s23plus",
        brand: "Samsung",
        name: "Galaxy S23+",
        mask: `${ASSET_BASE}/5gcok327_galaxy_s23_p_01.png`,
        mockup: `${ASSET_BASE}/qtdje0kw_galaxy_s23_p_02.png`,
    },
    {
        id: "s23",
        brand: "Samsung",
        name: "Galaxy S23",
        mask: `${ASSET_BASE}/1tjgxeab_galaxy_s23_01.png`,
        mockup: `${ASSET_BASE}/t4mnxt71_galaxy_s23_02.png`,
    },
    {
        id: "s23fe",
        brand: "Samsung",
        name: "Galaxy S23 FE",
        mask: `${ASSET_BASE}/1jud3tdm_galaxy_s23_fe_01.png`,
        mockup: `${ASSET_BASE}/6nfj9fj8_galaxy_s23_fe_02.png`,
    },
    {
        id: "s22plus",
        brand: "Samsung",
        name: "Galaxy S22+",
        mask: `${ASSET_BASE}/vj4jcu1l_galaxy_s22_p_01.png`,
        mockup: `${ASSET_BASE}/3rbtvcbz_galaxy_s22_p_02.png`,
    },
    {
        id: "pixel10",
        brand: "Google",
        name: "Pixel 10",
        mask: `${ASSET_BASE}/3rdeeps9_pixel_10_01.png`,
        mockup: `${ASSET_BASE}/w4ot232r_pixel_10_02.png`,
    },
    {
        id: "pixel9pro",
        brand: "Google",
        name: "Pixel 9 Pro",
        mask: `/masks/pixel_9_pro_mask.png`,
        mockup: `${ASSET_BASE}/zuz9r4yf_pixel_9_pro_02.png`,
    },
    {
        id: "pixel9",
        brand: "Google",
        name: "Pixel 9",
        mask: `/masks/pixel_9_pro_mask.png`,
        mockup: `${ASSET_BASE}/zuz9r4yf_pixel_9_pro_02.png`,
    },
    {
        id: "pixel8pro",
        brand: "Google",
        name: "Pixel 8 Pro",
        mask: `${ASSET_BASE}/f7deulld_pixel_8_pro_01.png`,
        mockup: `${ASSET_BASE}/fcecx33i_pixel_8_pro_02.png`,
    },
    {
        id: "pixel8",
        brand: "Google",
        name: "Pixel 8",
        mask: `${ASSET_BASE}/19rbpqk8_pixel_8_01.png`,
        mockup: `${ASSET_BASE}/y3kl0jj2_pixel_8_02.png`,
    },
];

export const LOGO_URL = `${ASSET_BASE}/hwahvs1g_Vend%201-01.webp`;

export function getModelById(id) {
    return PHONE_MODELS.find((m) => m.id === id) || PHONE_MODELS[0];
}
